// extracted by css-extract-rspack-plugin
export default {"DatasetsListItem":"EMspb","InfoIcon":"mFmBl","RemoveButton":"L1Yy2","TableIcon":"DAket","AddButton":"sZma6","DatasetsListItemSelected":"ICxJy","DatasetsListItemActions":"UDlLe"};